import { UspItem } from '../../@blocks/UspSection/UspSection';
import { CartInterface } from '../Cart/Cart';
import { PaymentMethod } from '../PaymentMethod/PaymentMethod';

export const trackedOrderIdsKey = 'trackedOrderIds';

export interface OrderInterface extends CartInterface {
    paymentMethods?: PaymentMethod[];
    paymentEnvironmentUrl?: string;
}

export interface ExtendedOrderInterface extends OrderInterface {
    uspItems: UspItem[];
}
